// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner--spinner--6brm7","graphic":"Spinner--graphic--4M4mD","spin":"Spinner--spin--FjbGa"};